<template>
  <Page title="Data Pengguna">
    <template v-slot:toolbar>
      <v-btn small @click="showRolesPage = true">+ Role</v-btn>
    </template>
    <Grid
      :datagrid.sync="users"
      dbref="Arch.User"
      style="height:calc(100vh - 120px)"
      class="dense"
      :doRebind="gridRebind"
      :columns="[
        {
          name: 'Username',
          value: 'Username',
          width: '150px',
          editable: {
            com: 'Input',
          },
        },
        {
          name: 'Password',
          value: 'Password',
          width: '120px',
          editable: {
            com: 'Input',
            type: 'password',
          },
        },
        {
          name: 'Nama Lengkap',
          value: 'FullName',
          width: '180px',
          editable: {
            com: 'Input',
          },
        },
        {
          name: 'Aktif ?',
          value: 'IsActive',
          width: '70px',
          editable: {
            com: 'Checkbox',
          },
        },
        {
          name: 'Role',
          class: 'plain',
          value: 'RolePositionName',
          editable: {
            com: 'Select',
            value: 'RolePositionID',
            text: 'RolePositionName',
            dbref: 'Arch.SelRolePosition',
          },
        },
        {
          name: 'Balai',
          class: 'plain',
          value: 'NamaBalai',
          editable: {
            com: 'Select',
            value: 'CityID',
            text: 'NamaBalai',
            dbref: 'MST.SelBalai',
          },
        },
      ]"
    >
      <template v-slot:row-IsActive="{ row }">
        <div center>
          <v-icon :color="row.IsActive ? 'primary' : ''">
            {{ row.IsActive ? 'mdi-checkbox-marked' : 'mdi-crop-square' }}
          </v-icon>
        </div>
      </template>
      <template v-slot:row-RolePositionName="{ row }">
        <v-btn
          text
          small
          color="primary"
          @click="ShowRoleAccess(row.RolePositionID)"
        >
          {{ row.RolePositionName }}
        </v-btn>
      </template>
    </Grid>
    <Modal
      id="modal-role-access"
      :show.sync="roleAccess"
      title="ROLE ACCESS"
      width="350px"
      @submit="SubmitRoleAccess"
    >
      <RoleAccessPage :roleId="roleId" :page-data.sync="roleAccessData" />
    </Modal>
    <Modal
      id="modal-roles"
      :show.sync="showRolesPage"
      title="ROLES"
      cancelText="TUTUP"
      :submitText="''"
    >
      <RolesPage :page-data.sync="rolesData" />
    </Modal>
    <Modal
      id="modal-roles"
      :show.sync="showAreaAccess"
      title="AREA AKSES"
      @submit="SubmitAreaAccess"
    >
      <AreaAccessPage :userId="userId" :page-data.sync="areaAccessData" />
    </Modal>
  </Page>
</template>
<script>
import RoleAccessPage from './RoleAccess'
import RolesPage from './Roles'
import AreaAccessPage from './AreaAccess'

export default {
  components: {
    RoleAccessPage,
    RolesPage,
    AreaAccessPage,
  },
  data: () => ({
    gridRebind: 1,
    roleAccess: false,
    showRolesPage: false,
    showAreaAccess: false,
    roleAccessData: [],
    rolesData: [],
    areaAccessData: [],
    roleId: null,
    userId: null,
    users: null,
    forms: {},
  }),
  async mounted() {},
  watch: {
    showRolesPage(val) {
      if (!val) {
        this.gridRebind++
      }
    },
  },
  methods: {
    ShowRoleAccess(roleId) {
      this.roleAccess = true
      this.roleId = roleId
    },
    ShowAreaAccess(userId) {
      this.showAreaAccess = true
      this.userId = userId
    },
    async SubmitRoleAccess() {
      let ret = await this.$api.call('Arch.SavRoleAccess', {
        RolePositionID: this.roleId,
        XmlRoleAccess: this.roleAccessData,
      })
      if (ret.success) this.roleAccess = false
    },
    async SubmitAreaAccess() {
      let ret = await this.$api.call('Arch.SavUserArea', {
        UserID: this.userId,
        Remarks:
          ',' +
          this.areaAccessData
            .filter(a => a.AllowAccess)
            .map(a => a.AreaID)
            .join(',') +
          ',',
      })

      if (ret.success) this.showAreaAccess = false
    },
  },
}
</script>
<style lang="scss">
#modal-role-access {
  .ui-table {
    height: 500px !important;
  }
}
</style>
